module.exports = __webpack_public_path__ + "img/hn.3dfdcd84.png";